/**
 * Print utilities — apertura sicura di finestra per stampa,
 * senza usare document.write (XSS-prone) e con HTML-escape dei valori dinamici.
 */

/** Escape valori per inserimento sicuro in HTML body/attribute */
export const escapeHtml = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[c]));
};

/**
 * Apre una nuova finestra con HTML statico, usando Blob URL.
 * Non usa document.write (vulnerabilità XSS storica + deprecato).
 * Il chiamante deve aver già HTML-escapato i valori dinamici nell'html.
 *
 * @param {string} html  HTML completo (con <!DOCTYPE>)
 * @param {object} opts  { width, height, errorMessage }
 * @returns {Window|null} la window aperta o null se popup bloccato
 */
export const openPrintWindow = (html, opts = {}) => {
  const { width = 800, height = 900 } = opts;
  const blob = new Blob([html], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, '_blank', `width=${width},height=${height}`);
  if (!w) {
    URL.revokeObjectURL(url);
    return null;
  }
  // Cleanup dopo 30s: la finestra ha già caricato l'HTML in memoria.
  setTimeout(() => URL.revokeObjectURL(url), 30000);
  return w;
};
